import { render, staticRenderFns } from "./cityPage.vue?vue&type=template&id=38d1254e&scoped=true"
import script from "./cityPage.vue?vue&type=script&lang=js"
export * from "./cityPage.vue?vue&type=script&lang=js"
import style0 from "./cityPage.vue?vue&type=style&index=0&id=38d1254e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d1254e",
  null
  
)

export default component.exports